import { isPlainObject } from 'lodash';

import decodeInputEvent from './decodeInputEvent';

// Collects the dot paths present across the fetched input events, for the advanced-search field
// autocomplete. Descending into an array appends a [*] wildcard (properties.products[*].sku) so the
// hints match the filter engine's any-element fan-out syntax.
export default function collectPayloadPaths(events) {
  const paths = new Set();

  events.forEach(event => {
    addPaths({ paths, value: decodeInputEvent(event), prefix: '' });
  });

  return [...paths].sort();
}

function addPaths({ paths, value, prefix }) {
  if (Array.isArray(value)) {
    value.forEach(element => addPaths({ paths, value: element, prefix: `${prefix}[*]` }));
    return;
  }

  if (isPlainObject(value)) {
    Object.entries(value).forEach(([key, child]) => {
      const path = prefix ? `${prefix}.${key}` : key;
      paths.add(path);
      addPaths({ paths, value: child, prefix: path });
    });
  }
}
